import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=a4454eca&scoped=true&"
import script from "./CategoryPage.vue?vue&type=script&lang=js&"
export * from "./CategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=a4454eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4454eca",
  null
  
)

export default component.exports